"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _history = require("history");
var _Modal = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = (0, _history.createBrowserHistory)({
  getUserConfirmation(message, callback) {
    // Show some custom dialog to the user and call
    // callback(true) to continue the transiton, or
    // callback(false) to abort it.
    return _Modal.default.confirm({
      title: "Confirm",
      content: message,
      onCancel: () => callback(false),
      onOk: () => callback(true)
    });
  }
});